import * as React from 'react';
import {useState, useMemo} from 'react';
import {Grid} from '@material-ui/core';
import Collapsible from 'react-collapsible';

export default function DocentAboTLinkWithSubscriptionData({data}) {
    const [isHovered, setIsHovered] = useState(false);

    const assuName = useMemo(() => {
        const {teacherfirstname, teacherlastnameprefix, teacherlastname} = data;
        return `${teacherfirstname}${teacherlastnameprefix ? ` ${teacherlastnameprefix}` : ``}${teacherlastname ? ` ${teacherlastname}` : ``}`;
    }, [data]);

    return <Collapsible
        open={false}
        trigger={
            <Grid container onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} style={{fontSize: '18px', color: isHovered ? '#898989' : '#4a474c'}}>
                <Grid container direction="row" style={{fontSize: '12px'}}>
                    <Grid item xs={3}>
                        {'Aangemaakt: '}
                        {new Date(data.createdat).toLocaleString()}
                    </Grid>
                    <Grid item xs={8}>
                        {'Laatst gewijzigd: '}
                        {new Date(data.updatedat).toLocaleString()}
                    </Grid>
                </Grid>
                <Grid item xs={11}>
                    {`AssuId - ${data.teacherassuid}      ${data.ean} - ${data.title}`}
                </Grid>
            </Grid>
        }
        transitionTime={200}
    >
        <pre>
            <div>ValidatieStatus: {data.validationstatus} </div>
            <div>Assu-naam: {assuName}</div>
            <div>Verlengen: {data.autorenew ? 'ja' : 'nee'}</div>
        </pre>
    </Collapsible>
}
